module.exports = __webpack_public_path__ + "static/media/piranha-vermelha.e7a5efc7.mp3";